import styled from 'styled-components';

export const StyledLayout = styled.div`
  text-align: right;
  width: 100%;
  margin-top: 18px;
  padding-right: 18px;
`;
export default StyledLayout;
